<div>
	<img src="/assets/img/icon-pdf.png" alt="pdf" width="12px" height="12px" />
	<a [href]="downloadLink" download target="_blank" class="XCdocument-name">{{ documentName }}</a>
</div>
